export default {"src":"/_next/static/media/key-white.6edab422.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};